'use strict';

var _ = require('lodash');
var SimpleGridFormattersService = function SimpleGridFormattersService($filter, momentService) {
  var rmPercentFormat = $filter('rmPercent');
  var rmMomentFormat = $filter('rmMomentFormat');
  var rmNumberFormat = $filter('rmNumberFormat');
  var FORMATTERS = {
    'date': function date(value, format) {
      if (momentService.isMoment(value)) {
        var momentFormat = format || (value.isTime() ? 'TIME_USER_SETTINGS' : 'DATE_USER_SETTINGS');
        return rmMomentFormat(value, momentFormat);
      }
    },
    'percentage': function percentage(value) {
      return !_.isNil(value) ? rmPercentFormat(value, 0) + '%' : '';
    },
    'nodecimal': function nodecimal(value) {
      var formattedNumber = rmNumberFormat(value, 'NO_DECIMAL');
      return formattedNumber !== 'N/A' ? formattedNumber : '';
    }
  };
  function getFormatterFor(type) {
    return FORMATTERS[type];
  }
  return {
    getFormatterFor: getFormatterFor
  };
};
SimpleGridFormattersService.$inject = ['$filter', 'MomentService'];
module.exports = SimpleGridFormattersService;